import { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken, formatError } from "../lib/api";

const AuthContext = createContext(null);
const TOKEN_KEY = "korio_admin_token";

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const boot = async () => {
      const t = localStorage.getItem(TOKEN_KEY);
      if (!t) { setReady(true); return; }
      setAuthToken(t);
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
        setToken(t);
      } catch {
        localStorage.removeItem(TOKEN_KEY);
        setAuthToken(null);
        setToken(null);
      } finally {
        setReady(true);
      }
    };
    boot();
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem(TOKEN_KEY, data.token);
      setAuthToken(data.token);
      setToken(data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatError(e) };
    }
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setAuthToken(null);
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ token, user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
